<template>
    <section class="visits">
        <div class="container visits__container">

            <BackButton
                    containerClass="visits__btn"
                    defaultRoute="/members/dashboard"
            />

            <div class="attention">
                <div class="attention__pic"><img src="@/assets/images/dashboard/info.svg" alt=""></div>
                <div class="attention__text">
                    {{$t('members.view-my-visits.attention')}}
                </div>
            </div>


            <Table
                    :table-head="header"
                    :table-body="body"
                    :tableData="tableData"
                    :request-function="getClientsVisits"
                    moreMode="table"
            />

            <partners class="visits__partners"/>

        </div>
    </section>

</template>

<script>
    import { mapGetters } from 'vuex';
    // import Table from "@/elements/Table/Table";
    import { getClientsVisits } from "@/api/clientServices";
    import Table from "@/elements/Table/Table";
    import partners from '@/components/members/Partners'

    export default {
        components: {
            Table,
            partners
            // Table,
        },

        data() {
            return {
                getClientsVisits: getClientsVisits,
            }
        },

        computed: {
            ...mapGetters([
                'tableData',
            ]),

        header() {
            return [
                {
                    name: 'training_date',
                    width: '250px',
                    adaptiveMode: 'mobile'

                },
                {
                    name: 'studio_name',
                    width: '250px',
                    adaptiveMode: 'mobile'

                },
                {
                    name: 'passCode',
                    adaptiveMode: 'tablet',
                    width: '150px'
                },
                {
                    name: 'city',
                    adaptiveMode: 'tablet',
                    width: '100px'
                },
                {
                    name: 'country',
                    width: '100px',
                    adaptiveMode: 'none'
                }

            ]
        },

        body() {
            let arr = [];
            this.tableData.data && this.tableData.data.forEach(item => {
                console.log(item, 'item')
            arr.push({
                    training_date: item.created_at,
                    studio_name: item.studio_name,
                    passCode: item.pass_code,
                    city: item.studio_city,
                    country: item.studio_country ? item.studio_country.title : ''
            })
        });
            return arr;
        }
    },

    async created() {
        await this.$store.dispatch('PAGINATE', {page: 1, requestFunction: this.getClientsVisits});
    },
    }
</script>

<style lang="sass">
    .visits

        &__btn
            flex: initial
            margin-bottom: 16px

        &__partners
            margin-top: 40px
</style>
